import './../../css/style.css'


function HeaderInfo() {

    return (
        <>
            <p className='info'>
                SCOTIABANK URUGUAY S.A. se interesa por la seguridad y confidencialidad de su información. Por eso le informamos lo siguiente:
            </p>
            <p className='info'>
                1. Los datos que usted ingresa están siendo proporcionados a SCOTIABANK URUGUAY S.A. (en adelante "El Banco"), con RUT N° 214765780014 y domicilio en Misiones 1399, para ser incluidos en su base de datos. 2. La finalidad de esta base de datos es para la posterior generación de las Tarjetas de Débito con programa de premios que elija el solicitante. 3. En todo momento Ud. podrá acceder a sus datos ya sea para excluirlos, modificarlos o actualizarlos.
            </p>
            <p className='info'>
                Por la presente, autorizo a Scotiabank Uruguay S.A. a facilitarle mediante este sitio web, el acceso a la información sobre mis datos personales, a los efectos de su visualización y actualización. Asimismo autorizo a tratar los datos personales que aporto en forma voluntaria mediante este sitio web, para la finalidad antes indicada, en un todo de acuerdo a las disposiciones de la Ley Nº 18.331, de 11 de agosto de 2008, de Protección de Datos Personales y Acción de Habeas Data.
            </p>
            
        </>
    );
}

export { HeaderInfo }